import { g } from "./preact.module-B5ZnQuyU.js";
import { f as formatMoney } from "./currency-DRNmrEpZ.js";
const Price = ({
  product,
  useVariant = true,
  priceClass = ""
}) => {
  const target = useVariant ? product.variants[0] : product;
  const compareAtPrice = product.compare_at_price;
  const productPrice = product.price;
  const available = Boolean(target);
  const availableVariants = product.variants.filter((variant) => {
    if (variant.available) {
      if (variant.inventory_quantity && variant.outOfStockThreshold && variant.inventory_quantity <= variant.outOfStockThreshold) {
        return false;
      }
      return true;
    }
  });
  const lastVariant = availableVariants.length > 1 ? availableVariants[availableVariants.length - 1] : product.variants[0];
  const {
    canAmount: lastVariantCanAmount = "",
    millilitres: lastVariantMillilitres = "",
    real_compare_at_price: realCompareAtPrice = "",
    price_per_can: lastVariantPricePerCan = "",
    compare_price_per_can: lastVariantComparePricePerCan = ""
  } = lastVariant || {};
  const pricePerCan = lastVariantPricePerCan;
  const compareAtPricePercan = lastVariantComparePricePerCan;
  const perCanText = window.themeVars.strings.product.perCan;
  let perLitreText = "";
  if (lastVariantMillilitres) {
    if (availableVariants.length > 1) {
      perLitreText = ` | ${window.themeVars.strings.product.from} ${lastVariantMillilitres} / liter`;
    } else {
      perLitreText = ` | ${lastVariantMillilitres} / liter `;
    }
  }
  if ((realCompareAtPrice == null ? void 0 : realCompareAtPrice.length) > 0 && available) {
    priceClass = "price--on-sale";
  } else {
    priceClass = "price__regular";
  }
  const CanPricing = () => /* @__PURE__ */ g("p", { className: "price__can" }, window.themeVars.strings.product.from, " ", compareAtPricePercan !== "£0.00" && /* @__PURE__ */ g("span", { className: "price price__compare-at" }, compareAtPricePercan), /* @__PURE__ */ g("span", { className: `price ${priceClass}` }, pricePerCan), perCanText);
  return /* @__PURE__ */ g(
    "div",
    {
      className: `price ${priceClass} ${!available ? "price--sold-out" : ""} ${(realCompareAtPrice == null ? void 0 : realCompareAtPrice.length) > 0 ? "price--on-sale" : ""}`
    },
    /* @__PURE__ */ g("div", { className: "price__container" }, lastVariantCanAmount && !lastVariantMillilitres ? /* @__PURE__ */ g(CanPricing, null) : /* @__PURE__ */ g("div", null, realCompareAtPrice ? /* @__PURE__ */ g("span", null, /* @__PURE__ */ g("span", { className: "visually-hidden" }, window.themeVars.strings.product.price.sale), /* @__PURE__ */ g("span", { className: "price__compare-at" }, formatMoney(realCompareAtPrice))) : compareAtPrice ? /* @__PURE__ */ g("span", null, /* @__PURE__ */ g("span", { className: "visually-hidden" }, window.themeVars.strings.product.price.regular), /* @__PURE__ */ g("span", { className: "price__compare-at" }, compareAtPrice)) : null, /* @__PURE__ */ g("span", { className: "visually-hidden" }, window.themeVars.strings.product.price.regular), compareAtPrice && !realCompareAtPrice ? /* @__PURE__ */ g("span", { className: "price__regular" }, productPrice) : /* @__PURE__ */ g("span", { className: `price ${priceClass}` }, lastVariant.price), lastVariantMillilitres && /* @__PURE__ */ g("span", { className: "price__per-can litres text-sm-body" }, perLitreText)))
  );
};
export {
  Price as P
};
